const ApiStore = require("stores/abstract/ApiStore");
const router = require("services/router");
const PageContext = require("services/PageContext");
const downloadjs = require("downloadjs");

const {observable} = require("mobx");

const Auth = require("services/Auth");

class CrudStore extends ApiStore {

    @observable selected = new Set();
    @observable active = null;

    constructor(resource, constraints = {}, autofetch = true, context = null) {

        const options = {
            endpoint: router.route("backend_api." + resource + ".index")
        };

        super([], constraints, {}, options);

        this.resource = resource;

        this.collectionChange.pipe(collection => {
            return collection.map(entry => {
                entry.getResource = () => this.resource;
                entry.getStore = () => this;

                return entry;
            });
        });

        this.parent_store = null;

        this.context_reaction = null;

        if (context === null) {
            context = PageContext;
        }

        this.setContext(context, true);

        if (autofetch) {
            this.fetch();
        }
    }

    setParent(parent) {
        this.parent_store = parent;
    }

    setupContextReaction(fire = false) {
        mobx.reaction(
            () => this.context.params[this.resource],
            (data, reaction) => {
                this.context_reaction = reaction;
                this.context_reaction.current_context = this.context;

                //console.log('REACTION', this.context_reaction);

                this._updateActive(data);
            },
            {fireImmediately: fire}
        );
    }

    setContext(context, fire = false) {
        this.context = context;

        if (this.context_reaction !== null) {

            if (this.context_reaction.current_context !== this.context) {

                this.context_reaction.dispose();
                this.context_reaction = null;

                this.setupContextReaction(fire);
            }

        } else {
            this.setupContextReaction(fire);
        }

    }

    onActiveCallbacks = {};

    onActiveUpdated(name, callback) {
        if (typeof(callback) === 'function') {
            this.onActiveCallbacks[name] = callback;
        }
    }

    removeOnActiveUpdatedCallback(name) {
        if (typeof(this.onActiveCallbacks[name]) !== 'undefined') {
            delete this.onActiveCallbacks[name];
        }
    }

    handleActiveUpdated = () => {
        let callbacks = Object.values(this.onActiveCallbacks);
        if (callbacks.length > 0) {
            callbacks.forEach(callback => {
                callback(this.active);
            });
        }
    }

    _updateActive = (id) => {

        return new Promise((resolve, reject) => {
            //console.log('UPDATING ACTIVE', this.resource, id);

            if (!id) {
                if (this.active !== null) {
                    this.active = null;
                    this.handleActiveUpdated();
                }

                return resolve(this.active);
            }

            this.read(id)
                .then(data => this.active = data)
                .then(this.handleActiveUpdated)
                .then(() => resolve(this.active))
                .catch(() => this._updateActive(null));
        });

    }

    updateActive = () => {
        return new Promise((resolve, reject) => {

            if (this.active !== null && typeof(this.active) !== 'undefined') {
                return this._updateActive(this.active.id)
                    .then(() => resolve(this.active));
            }

            resolve(this.active);
        });
    }

    /////////////////////////////////
    // Checks
    /////////////////////////////////

    isSelected(id) {
        return this.selected.has(id);
    }

    allSelected() {
        if (this.collection.length < 1) return false;

        return this.collection.every(e => this.isSelected(e.id));
    }

    /////////////////////////////////
    // Public methods
    /////////////////////////////////

    getSelected() {
        return Array.from(this.selected);
    }

    clearSelected() {
        this.selected = new Set();
    }

    toggleAll(bol) {
        this.collection.forEach(e => this._toggleSelected(e.id, bol));
        this._updateSelected();
    }

    toggleSingle(id, bol) {
        this._toggleSelected(id, bol);
        this._updateSelected();
    }

    /////////////////////////////////
    // Private methods
    /////////////////////////////////

    _updateSelected() {
        this.selected = new Set(this.selected);
    }

    _toggleSelected(id, is_selected) {
        is_selected ?
            this.selected.add(id) :
            this.selected.delete(id);
    }

}

module.exports = CrudStore;
